import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { AlertDialogComponent, ConfirmDialogModel } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import {
  MatAutocompleteSelectedEvent,
  MatAutocomplete,
  MatAutocompleteTrigger,
} from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { Observable, Subscription, of } from 'rxjs';
import { distinctUntilChanged, map, startWith, tap } from 'rxjs/operators';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { environment } from "src/environments/environment";
import { UserProfileService } from "src/app/core/http/user-profile.service";
import { DataService } from "src/app/services/data.service";
import { AlertService, AlertType } from "src/app/services/alert.service";
import { untilDestroyed } from 'src/app/core/until-destroyed';
import { AdUserProfile } from 'src/app/models/ad-user-profile';
import * as CryptoJS from 'crypto-js';

@Component({
    selector: 'app-add-offline-testslip',
    templateUrl: './add-offline-testslip.component.html',
    styleUrls: ['./add-offline-testslip.component.scss'],
    standalone: false
})
export class AddOfflineTestslipComponent implements OnInit {
  panelOpenState: boolean;
  offlineTestSlipId: string;
  statusName: string = 'In Progress';
  smthAuditTrails: any;
  testslipDetailsForm: UntypedFormGroup;
  files: Array<any> = [];
  comments = "";
  enableAddComments: boolean = false;
  smthOrgStructure: Array<any> = [];
  sfiOption: Array<any> = [
    {
      value: 'Yes',
      id: 1
    },
    {
      value: 'No',
      id: 0
    }
  ]

  selectable: boolean = true;
  removable: boolean = true;
  smthPlanCtrl = new UntypedFormControl();
  testerCtrl = new UntypedFormControl();
  separatorKeysCodes: number[] = [ENTER, COMMA];
  filteredSmthPlans: Observable<string[]>;
  filteredUsers: Observable<AdUserProfile[]>;
  userDetails: AdUserProfile[];
  smthPlans: any[] = [];
  allSmthPlans: any[] = [];
  @ViewChild('smthPlanInput') smthPlanInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  @ViewChild('autocompleteTrigger') matACTrigger: MatAutocompleteTrigger;
  subscription: Subscription;
  userDetailsSubscription: Subscription;
  smthTestPlanSubscription: Subscription;
  commentsSubscription: Subscription;
  saveSlipDetailsSubscription: Subscription;
  showLoader: boolean = false;

  constructor(
    private router: Router,
    private fb: UntypedFormBuilder,
    public dialog: MatDialog,
    private ds: DataService,
    private alertService: AlertService,
    private userProfileService: UserProfileService
  ) {
    this.subscription = this.testerCtrl
      .valueChanges.subscribe((value) => {
        if (value) {
          value.length >= 3 ? this.getUsers(value) : (this.filteredUsers = of([]));
        }
      }
      );
  }

  ngOnInit(): void {
    this.generateId();
    this.createFrom();
    this.getSmthPlans();
  }

  public displayProperty(value) {
    if (value) {
      return value.displayName;
    }
  }

  createFrom() {
    this.testslipDetailsForm = this.fb.group({
      faultNo: ['', Validators.required],
      workorderNo: ['', Validators.required],
      site: ['', Validators.required],
      assetId: ['', Validators.required],
      depotId: ['', Validators.required],
      workDetails: ['', Validators.required],
      workers: ['', Validators.required],
      testerId: ['', Validators.required],
      testPlan: ['', Validators.required],
      isSFI: ['', Validators.required],
      comments: ['']
    })

    this.smthPlanCtrl.valueChanges.subscribe(
     (value: string | null) => {
      this.filteredSmthPlans = value ? of(this.filterSmthPlans(value)) : of(this.allSmthPlans.slice())
      }
    );

    this.testslipDetailsForm.get('faultNo').valueChanges.pipe(distinctUntilChanged()).subscribe(value => {
      if (value) {
        this.testslipDetailsForm.get('workorderNo').setValidators(null);
      } else {
        this.testslipDetailsForm.get('workorderNo').setValidators([Validators.required]);
      }
      this.testslipDetailsForm.get('workorderNo').updateValueAndValidity();
    })

    this.testslipDetailsForm.get('workorderNo').valueChanges.pipe(distinctUntilChanged()).subscribe(value => {
      if (value) {
        this.testslipDetailsForm.get('faultNo').setValidators(null);
      } else {
        this.testslipDetailsForm.get('faultNo').setValidators([Validators.required]);
      }
      this.testslipDetailsForm.get('faultNo').updateValueAndValidity();
    })

  }

  getUsers(value: string) {
    const searchResults = [];
    let url = environment.BASEURL + environment.GET_SYSUSER_BY_TEXT.replace(
      '{keyWord}',
      value
    );
    this.userDetailsSubscription = this.ds.getService(url)
      .pipe(untilDestroyed(this))
      .subscribe(data => {
        let decriptdata = this.ds.decrypt(
          environment.ENCRYPTKEY_DATA,
          data?.users
        );
        this.userDetails = JSON.parse(decriptdata);
        this.userDetails.forEach((item) => {
          searchResults.push(item);
        });
        this.filteredUsers = of(
          searchResults.length > 0
            ? searchResults.filter((e) => {
              return (e.displayName != null && e.mail != null && e.userPrincipalName != null);
            })
            : ['no data found']
        );
      });
  }

  generateId() {
    this.offlineTestSlipId = 'P' + new Date().getTime();
    this.smthAuditTrails = [{
      statusName: this.statusName,
      modifiedDate: '',
      modifiedByName: '',
      modifiedByEmail: ''
    }]
    this.getDepot();
  }

  getDepot() {
    this.smthOrgStructure = this.userProfileService.currentUserObject.smthOrgStructure;
  }

  getSmthPlans() {
    this.smthTestPlanSubscription = this.ds.getService(
      environment.BASEURL + environment.TEST_PLANS.replace(
        '{userId}', '0'))
      .pipe(untilDestroyed(this))
      .subscribe(result => {
        this.allSmthPlans = result;
        this.filteredSmthPlans = of(this.allSmthPlans);
      })
  }

  backButtonNavigate() {
    this.router.navigate(["/dashboard"]);
  }

  submitTestSlip() {
    if (this.files.length === 0) {
      this.alertService.showAlertDialog(
        "Please attach document.",
        AlertType.alert
      );
      return;
    }
    this.showLoader = true;
    const formValue = JSON.parse(JSON.stringify(this.testslipDetailsForm.value));
    const testPlans = [];
    formValue.testPlan.forEach(plan => {
      testPlans.push({ testPlanId: plan.id })
    });

    delete formValue['testPlan'];
    formValue.depotId = Number(formValue.depotId);
    formValue.depot = Number(formValue.depotId);
    formValue.tester = Number(formValue.testerId);
    formValue.isSFI = Number(formValue.isSFI);
    formValue.status = 2;
    formValue.userId = this.userProfileService.currentUserObject.id;

    const params = {
      testSlipDetails: testPlans,
      smthTestSlip: {
        testSlipId: this.offlineTestSlipId,
        testDateTime: new Date(),
        ...formValue
      }
    }

    const encryptedParams = btoa(JSON.stringify(params));
    let formData = new FormData();
    formData.append("formFieldsData", encryptedParams)


    let url = environment.BASEURL + environment.VIEWTESTSLIP;

    this.saveSlipDetailsSubscription = this.ds.createService(url, formData)
      .subscribe(id => {
        this.addComment(id);
      }, (error) => {
        this.showLoader = false;
      })
  }

  addComment(id) {
    const commentDateTime = new Date(
      new Date().toString().split("GMT")[0] + " UTC"
    ).toISOString();

    const formData = new FormData();
    this.files.forEach(file => {
      formData.append('formFiles', file);
    });

    const payload = {
      SmthComments: {
        id: 0,
        testSlipId: id,
        comments: this.comments,
        commentedBy: this.userProfileService.currentUserObject.id,
        commentedDate: commentDateTime
      }
    };

    const smthComments = btoa(JSON.stringify(payload));
    formData.append("SmthComments", smthComments);

    let url = environment.BASEURL + environment.ADD_COMMENTS;

    this.commentsSubscription = this.ds.createService(url, formData)
      .subscribe((res) => {
        this.showLoader = false;
        this.navigateToDetailsPage(id);
      }, (error) => {
        this.showLoader = false;
      });
  }

  navigateToDetailsPage(id) {
    const encryptedId = CryptoJS.AES.encrypt(JSON.stringify(id), environment.ENCRYPTKEY_DATA).toString();
    const navigationExtras: NavigationExtras = {
      queryParams: {
        testSlipId: encryptedId,
      },
    };

    this.router.navigate(["/view-testslips"], navigationExtras);
  }

  deleteAttachment(index) {
    let dialogData = new ConfirmDialogModel(
      "Alert",
      "Domments deleted successfully!!",
      "simpleconfirm"
    );
    this.confirmDialog("Do you want to delete the document?")
      .afterClosed()
      .subscribe((dialogResult) => {
        if (dialogResult) {
          this.files.splice(index, 1)
        }
      });
  }


  confirmDialog(message) {
    const dialogData = new ConfirmDialogModel(
      "SMTH Portal",
      message,
      "confirm"
    );
    const dialogRef = this.dialog.open(AlertDialogComponent, {
      height: "250px",
      width: "600px",
      data: dialogData,
    });

    return dialogRef;
  }

  uploadFile(event) {
    for (let index = 0; index < event.files.length; index++) {
      const element = event.files[index];
      const fileSize = Math.round((element.size / 1024));
      const allowedExtensions =
                    /(\.pdf|\.docx|\.jpg|\.jpeg|\.png|\.gif)$/i;

      if (!allowedExtensions.exec(event.value)) {
        this.alertService.showAlertDialog(
          'Invalid file type',
          AlertType.alert
        );
        event.value = '';
        return;
      }
      if(fileSize > environment.FILE_SIZE) {
        this.alertService.showAlertDialog(
          `File size exceeds maximum limit of ${Math.round(environment.FILE_SIZE/1024)}MB.`,
          AlertType.alert
        );
        return;
      }

      this.files.push(element);
      event.value = '';
    }
  }

  addPlans(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our plan
    if ((value || '').trim()) {
      this.smthPlans.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }

    this.smthPlanCtrl.setValue(null);
    this.testslipDetailsForm.get('testPlan').setValue(this.smthPlans);
  }

  toggleCheck(plan) {
    return this.smthPlans.findIndex(ele => ele.id == plan.id) >= 0;
  }

  remove(plan: any): void {
    const index = this.smthPlans.findIndex(ele => ele.id == plan.id);

    if (index >= 0) {
      this.smthPlans.splice(index, 1);
    }

    this.testslipDetailsForm.get('testPlan').setValue(this.smthPlans);
  }

  selectedPlans(event: MatAutocompleteSelectedEvent): void {
    const newValue = event.option.value;
    if (this.smthPlans.includes(newValue)) {
      this.smthPlans = [...this.smthPlans.filter((plan) => plan.id !== newValue.id)];
    } else {
      this.smthPlans.push(event.option.value);
    }
    this.smthPlanInput.nativeElement.value = '';
    this.smthPlanCtrl.setValue(null);
    this.testslipDetailsForm.get('testPlan').setValue(this.smthPlans);
    // keep the autocomplete opened after each item is picked.
    requestAnimationFrame(() => {
      this.openAuto(this.matACTrigger);
    });
  }

  private filterSmthPlans(value: any): string[] {
    const filterValue = typeof value === 'string' ? value.toLowerCase() : value?.testPlan;

    return this.allSmthPlans.filter(
      (plan) => plan.testPlan.toLowerCase().indexOf(filterValue) >= 0
    );
  }

  openAuto(trigger: MatAutocompleteTrigger) {
    trigger.openPanel();
    this.smthPlanInput.nativeElement.focus();
  }

  selectedTester(event) {
    this.testslipDetailsForm.get('testerId').setValue(event.option.value.userId);
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
    this.userDetailsSubscription?.unsubscribe();
    this.smthTestPlanSubscription?.unsubscribe();
    this.commentsSubscription?.unsubscribe();
    this.saveSlipDetailsSubscription?.unsubscribe();
  }
}
